export function pinAccordionProps(onChange: () => void, expandState = false, pinState = false) {
  return {
    expanded: expandState,
    noCollapse: pinState,
    onChange,
  };
}

export function pinProps(pinToggle: () => void, expandState = false, pinState = false) {
  return {
    expanded: expandState,
    pinned: pinState,
    onClick: pinToggle,
  };
}

export interface IPinnableAccordionProps {
  isExpanded: boolean;
  isPinned: boolean;
  pinToggle: () => void;
  handleToggle: () => void;
}
